import { Button } from "@themes/pollinator/ui/Button";

export type Props = {
  /** Handler for continue button */
  onContinue: () => void;
  /** Optional handler for skip button (hidden if undefined) */
  onSkip?: () => void;
  /** Continue button text */
  continueLabel?: string;
  /** Skip button text */
  skipLabel?: string;
};

/**
 * Action buttons for steps that need manual continue/skip.
 * Used for steps like send_invitation where the content doesn't trigger completion.
 */
export function ActionButtons({
  onContinue,
  onSkip,
  continueLabel = "Continue",
  skipLabel = "Skip for now",
}: Props) {
  return (
    <div className="flex gap-3 mt-4" data-testid="step-action-buttons">
      <Button
        onClick={onContinue}
        variant="primary"
        className="flex-1"
        data-testid="step-action-continue"
      >
        {continueLabel}
      </Button>
      {onSkip && (
        <Button
          onClick={onSkip}
          variant="ghost"
          data-testid="step-action-skip"
        >
          {skipLabel}
        </Button>
      )}
    </div>
  );
}

export default ActionButtons;
